import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import TopNav from './TopNav';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  // Gentelella requires body.nav-md for the expanded sidebar layout
  useEffect(() => {
    document.body.classList.add('nav-md');
    return () => {
      document.body.classList.remove('nav-md');
      document.body.classList.remove('nav-sm');
    };
  }, []);

  // Expose toggle to TopNav via a custom event
  useEffect(() => {
    const handler = () => setMobileOpen((v) => !v);
    window.addEventListener('ev-toggle-mobile-sidebar', handler);
    return () => window.removeEventListener('ev-toggle-mobile-sidebar', handler);
  }, []);

  // Close sidebar when route changes on mobile
  const closeMobile = () => setMobileOpen(false);

  return (
    <div className="container body">
      <div className="main_container">

        {/* ── Mobile overlay backdrop ── */}
        {mobileOpen && (
          <div
            onClick={closeMobile}
            style={{
              position: 'fixed',
              inset: 0,
              background: 'rgba(0,0,0,0.5)',
              zIndex: 1029,
            }}
          />
        )}

        {/* ── Sidebar ── */}
        <div
          className="col-md-3 left_col"
          style={
            // On mobile: slide in/out as a drawer
            window.innerWidth < 992
              ? {
                  transform: mobileOpen ? 'translateX(0)' : 'translateX(-100%)',
                  transition: 'transform 0.3s ease',
                  display: 'flex',
                  zIndex: 1030,
                }
              : {}
          }
        >
          <Sidebar onNavigate={closeMobile} />
        </div>

        {/* ── Top navigation ── */}
        <TopNav />

        {/* ── Main content ── */}
        <div className="right_col" role="main">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;
